(function () {
  function initMemeProductContact(scope) {
    const context = scope.querySelector('[data-product-context]');
    if (!context) return;
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('product') || '';
    if (!/^[a-z0-9-]{1,255}$/.test(handle)) return;
    const url = new URL(`/products/${handle}`, window.location.origin);
    const variant = params.get('variant') || '';
    if (/^\d{1,20}$/.test(variant)) url.searchParams.set('variant', variant);
    context.querySelector('[data-product-context-link]').href = url.href;
    const input = context.querySelector('[data-product-context-input]');
    input.value = url.href;
    input.disabled = false;
    context.hidden = false;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMemeProductContact(document), { once: true });
  } else {
    initMemeProductContact(document);
  }
  document.addEventListener('shopify:section:load', event => initMemeProductContact(event.target));
})();
